const gridObservers = new WeakMap();
const scheduledGrids = new WeakMap();

function getGrids(root = document) {
  if (root instanceof Element) {
    const grids = Array.from(root.querySelectorAll('results-list .product-grid[ref="grid"], .product-grid, .resource-list'));
    if (root.matches('results-list .product-grid[ref="grid"], .product-grid, .resource-list')) grids.unshift(root);

    return [...new Set(grids)];
  }

  return Array.from(document.querySelectorAll('results-list .product-grid[ref="grid"], .product-grid, .resource-list'));
}

function forceSort(grid) {
  if (!(grid instanceof HTMLElement)) return;

  const items = Array.from(grid.children).filter(
    (element) => element instanceof HTMLElement && element.hasAttribute('data-availability')
  );

  if (items.length === 0) return;

  const inStock = [];
  const outOfStock = [];

  items.forEach((element) => {
    if (element.dataset.availability === 'true') {
      inStock.push(element);
    } else {
      outOfStock.push(element);
    }
  });

  const newOrder = [...inStock, ...outOfStock];

  let changed = false;
  for (let index = 0; index < items.length; index += 1) {
    if (items[index] !== newOrder[index]) {
      changed = true;
      break;
    }
  }

  if (!changed) return;

  newOrder.forEach((element) => {
    grid.appendChild(element);
  });
}

function scheduleSort(grid) {
  if (!(grid instanceof HTMLElement)) return;

  const existingTimeouts = scheduledGrids.get(grid) || [];
  existingTimeouts.forEach((timeoutId) => clearTimeout(timeoutId));

  const timeouts = [200, 600, 1200].map((delay) =>
    window.setTimeout(() => {
      forceSort(grid);
    }, delay)
  );

  scheduledGrids.set(grid, timeouts);
}

function attachGridObserver(grid) {
  if (!(grid instanceof HTMLElement) || gridObservers.has(grid)) return;

  let isApplying = false;

  const observer = new MutationObserver(() => {
    if (isApplying) return;

    isApplying = true;
    scheduleSort(grid);

    window.setTimeout(() => {
      isApplying = false;
    }, 1300);
  });

  observer.observe(grid, { childList: true });
  gridObservers.set(grid, observer);
}

function runSorter(root = document) {
  const grids = getGrids(root);

  grids.forEach((grid) => {
    forceSort(grid);
    scheduleSort(grid);
    attachGridObserver(grid);
  });
}

document.addEventListener('DOMContentLoaded', () => runSorter(), { once: true });
document.addEventListener('shopify:section:load', (event) => {
  runSorter(event.target);
});
document.addEventListener('filter:update', () => {
  runSorter();
});
